import { Alert, Button, CircularProgress } from '@mui/material';
import ConnectorCard from '../ConnectorCard';
import { useAccount } from 'apps/aquifer-frontend/src/auth';
import { useSearchParams } from 'react-router-dom';
import { useOAuthAuthorize } from 'apps/aquifer-frontend/src/data/useOAuthAuthorize';

const OAuthStep = ({
  step,
  catalogType,
  entity,
  stepNumber,
  activeStep,
  onNextClick,
  onBackClick,
}: any) => {
  const { currentAccount } = useAccount();
  const [searchParams] = useSearchParams();
  const authorizeQuery = useOAuthAuthorize(currentAccount.id, entity.id);
  const active = activeStep === stepNumber - 1;

  const completed =
    entity?.config?.refresh_token && activeStep !== stepNumber - 1;

  const handleAuthorize = () => {
    const url =
      authorizeQuery.data && 'authorize_url' in (authorizeQuery.data as any)
        ? (authorizeQuery.data as any).authorize_url
        : '';
    window.location.href = url;
  };

  let error = null;
  const qsError = searchParams.get('error_description');
  if (qsError) {
    error = <Alert severity="error">{qsError}</Alert>;
  } else if (authorizeQuery.isError) {
    error = <Alert severity="error">Error fetching authorization URL</Alert>;
  }

  return (
    <ConnectorCard
      stepNumber={stepNumber}
      active={active}
      completed={completed}
      disabled={!active && !completed}
      title={step.title}
      subheader={`Click Authorize to be taken to ${catalogType.title} and authorize Aquifer to access your account.`}
      sx={{ marginBottom: '1em' }}
      {...(completed && { onNextClick })}
      onBackClick={onBackClick}
      renderChildren={(buttonsAreDisabled) => (
        <div
          style={{
            textAlign: 'center',
          }}
        >
          {active && error ? (
            error
          ) : (
            <Button
              disabled={Boolean(
                buttonsAreDisabled ||
                  !active ||
                  error ||
                  authorizeQuery.isLoading,
              )}
              fullWidth
              variant="contained"
              onClick={handleAuthorize}
            >
              {authorizeQuery.isLoading ? '...loading auth url' : 'Authorize'}
            </Button>
          )}
        </div>
      )}
    />
  );
};

export default OAuthStep;
